module.exports = __webpack_public_path__ + "assets/92015960764f826b3ad1c716590c4888.png";